<template src="./AppFutureWeather.html"></template>

<script>
export default {
  name: "app-future-weather",

  data() {
    return {
      futureDays: [],
    };
  },

  mounted() {
    this.setFutureDays();
  },

  watch: {
    "$store.state.weatherData"() {
      this.setFutureDays();
    },
  },

  methods: {
    setFutureDays() {
      const lstFutureDays = [];
      this.$store.state.weatherData.weather["day"] =
        this.$store.state.localization.data.TodayText;
      lstFutureDays.push(this.$store.state.weatherData.weather);
      lstFutureDays.push(...this.$store.state.weatherData.daily);
      lstFutureDays.forEach(item => {
        item.icon = item.icon.replace('-new', '');
      });
      this.futureDays = lstFutureDays;
    },
  },
};
</script>
